import { AgentStates } from 'types';
import { unitOfTime } from 'moment/moment';
import USDT from 'assets/crypto/usdt.svg';
import USDC0 from 'assets/crypto/USDT0.png';
import USDC from 'assets/crypto/usdc.svg';
import BTC from 'assets/crypto/btc.svg';
import HYPE from 'assets/crypto/hype.svg';
import FEUSD from 'assets/crypto/usde.png';
import USDe from 'assets/crypto/usde.png';
import { RewardStatus } from 'types/claim';
import { AccountType, TOKEN_NAME } from 'types/distribution';

export type HyperliquidChain = 'Mainnet' | 'Testnet';

export const CONSTANT = {
	testNet: 'testnet',
};
export const HYPER_CHAIN: HyperliquidChain = 'Mainnet';
export const HYPEREVM_CHAIN_ID_DEC = 999;
export const HYPEREVM_CHAIN_ID_HEX = '0x3e7';

export const BUILDER_ADDRESS = '0x9a3ce1C68A9798D812Adf47206799b5F6D98a3Cc';

export const DATE_TIME_FORMAT = 'DD MMM YYYY hh:mm A';

export const TEST_NET_URL = 'https://testnet.rndm.io?network=movement_porto';

export const APTOS_CONFIG = {
	id: '177',
	rpcUrl: 'https://aptos.testnet.porto.movementlabs.xyz/v1',
	name: 'testnet',
};
export const MOVE_VALUE = 100000000;

export const AGENT = 'cathena';

export const AGENT_MESSAGE: { [key in AgentStates]: string } = {
	created: 'Agent successfully created. Now start the Agent.',
	started: 'Agent successfully started',
	'stop-requested': 'Agent stop request successfully added',
	stopped: 'Agent successfully stopped',
};

export const THEME_COLOR = '#ffffff99'; //'#d6e3cf';

export type LockTimeType = {
	duration: number;
	difference: unitOfTime.Diff;
};

export const DEPOSIT_LOCK_TIME: LockTimeType = {
	duration: 1,
	difference: 'seconds',
};

export const WITHDRAW_LOCK_TIME: LockTimeType = {
	duration: 7,
	difference: 'days',
};
export const CLAIM_REWARD_LOCK_TIME: LockTimeType = {
	duration: 100,
	difference: 'seconds',
};

export const TOKEN: Record<TOKEN_NAME, { name: string; url: string }> = {
	USDT: {
		name: 'USDT',
		url: USDT,
	},
	USDC: {
		name: 'USDC',
		url: USDC,
	},
	USDT0: {
		name: 'USDC0',
		url: USDC0,
	},
	BTC: {
		name: 'BTC',
		url: BTC,
	},
	HYPE: {
		name: 'HYPE',
		url: HYPE,
	},
	feUSD: {
		name: 'feUSD',
		url: FEUSD,
	},
	USDe: {
		name: 'USDe',
		url: USDe,
	},
};

export const BLANK_ACCOUNT: AccountType = {
	points: {
		amount: 0,
		lifetimePoints: 0,
	},
	address: '',
	contract: '',
	tokens: [
		{
			tokenName: 'USDT0',
			tokenAddress: 'usdc-address',
			amount: 0,
			lifetimePNL: 0,
		},
	],
	id: '682103f0aa3a2c1781a944f6',
};

export const WITHDRAW_ADDRESS = '0x54fa8B396eC2036050Db3Fd360B60090b65C045C';

export const REWARD_COLOR: Record<RewardStatus, string> = {
	registered: '#275FF1',
	processing: '#FABD10',
	processed: '#1BAA75',
	rejected: '#FF7022',
};

export const SUGGESTION = [
	/*{
		id: 0,
		name: 'Vibecoding',
		value: 'Develop a trading agent for deployment in Binance, provide robust code with error handling',
	},*/
	{
		id: 1,
		name: 'Trading',
		value: 'Provide trading strategies for Hype which have low drawdowns',
	},
	{
		id: 2,
		name: 'Degen',
		value: 'Provide a memefied analysis for hype using degen strategies',
	},
];

export const AUTH_TOKEN = 'JeniusCApKNAufzqhH1Bw76ZwIDBPEcJLvqVQBunkDYViCdCg';

export const MOBILE_BREAK_POINTS = 700;

export const SIDEBAR_WIDTH = 300;

export const JENIUS_BASE_URL = 'https://jenius-staging.rndm.io';

export const VCRED_BASE_URL = 'https://apis.vcred.trade';
